// src/slices/drawResult/thunk.ts
// Async thunks cho Kết quả Quay số (số trúng thật theo từng kỳ)

import { createAsyncThunk } from '@reduxjs/toolkit';
import { getDrawResultByPlanApi, saveDrawResultApi, getIssuancePlansApi } from 'helpers/fakebackend_helper';
import { toast } from 'react-toastify';
import { ISSUANCE_PLAN_STATUS } from 'pages/IssuancePlan/types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('draw_result_messages');

// Danh sách kỳ phát hành cho dropdown chọn kỳ (cross-service, chỉ đọc — ticket-service)
// Mục 10, README.md — chỉ lấy kỳ đã "Hoàn thành kế hoạch" (đã nhận đủ vé thật từ nhà in, status
// Accept=5), vì kết quả quay số chỉ có ý nghĩa với những kỳ đã phát hành vé xong thực tế.
export const fetchIssuancePlanOptions = createAsyncThunk(
  'DrawResult/fetchIssuancePlanOptions',
  async (_: void, { rejectWithValue }) => {
    try {
      // PageIndex bắt đầu từ 1 -- quy tắc pagination toàn hệ thống (docs/pagination-rules.md)
      const response = await getIssuancePlansApi({
        PageIndex: 1,
        PageSize: 20,
        Status: ISSUANCE_PLAN_STATUS.Accept,
      });
      const payload: any = response;
      return payload?.items || payload?.Items || payload || [];
    } catch (error: any) {
      toast.error(st('khong_the_tai_danh_sach_ky_message'));
      return rejectWithValue(error?.response?.data?.message || error?.message);
    }
  }
);

// Kết quả quay số của 1 kỳ đang chọn, theo miền đang chọn trên FE
export const fetchDrawResultByPlan = createAsyncThunk(
  'DrawResult/fetchByPlan',
  async ({ issuancePlanId, region }: { issuancePlanId: number; region: string }, { rejectWithValue }) => {
    try {
      const response = await getDrawResultByPlanApi(issuancePlanId, region);
      return response as any;
    } catch (error: any) {
      const message = error?.response?.data?.message || error?.message || st('khong_the_tai_ket_qua_quay_text');
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

// Lưu kết quả quay số của 1 kỳ (ghi đè toàn bộ, theo miền)
export const saveDrawResult = createAsyncThunk(
  'DrawResult/save',
  async (
    { issuancePlanId, region, entries }: { issuancePlanId: number; region: string; entries: { prizeTierCode: string; winningNumbers: string[] }[] },
    { rejectWithValue }
  ) => {
    try {
      const response = await saveDrawResultApi(issuancePlanId, { region, entries });
      toast.success(st('luu_ket_qua_quay_so_thanh_message'));
      return response as any;
    } catch (error: any) {
      const message = error?.response?.data?.message || error?.message || st('khong_the_luu_ket_qua_quay_text');
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);
